import { render, staticRenderFns } from "./OrgTable.vue?vue&type=template&id=551c2fe8&scoped=true"
import script from "./OrgTable.vue?vue&type=script&lang=js"
export * from "./OrgTable.vue?vue&type=script&lang=js"
import style0 from "./OrgTable.vue?vue&type=style&index=0&id=551c2fe8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551c2fe8",
  null
  
)

export default component.exports